<template>
  <div>
    <div class="mb-1 d-flex flex-row">
      <div style="flex:1;" class="pr-2">
        <h6 style="color: #101010;">
          {{ $l('form_header_finance') || '业务设置' }}
        </h6>
      </div>
    </div>

    <el-form ref="baseForm" :model="formData" size="mini">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_financialRiskAssessment') || '财务风险评估'"
          >
            <el-input
              :value="$l('form_label_financialRiskAssessment_N') || '待评估'"
              readonly
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_paymentTerms') || '默认付款条件'"
          >
            <dict-select
              v-model="formData.paymentTerms"
              url="/master/common/dict/biz"
              :body="{ dictType: 'paymentTerms' }"
              :placeholder="
                $l('form_placeholder_paymentTerms') || '请选择默认付款条件'
              "
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="
              $l('form_label_discountSalesAmount') || '货款结算是否包含佣金'
            "
          >
            <el-select
              v-model="formData.discountSalesAmount"
              :placeholder="
                $l('form_placeholder_discountSalesAmount') ||
                  '请选择货款结算是否包含佣金'
              "
              filterable
              clearable
              style="width: 100%"
            >
              <el-option
                value="Y"
                :label="$l('form_label_discountSalesAmount_Y') || '包含佣金'"
              />
              <el-option
                value="N"
                :label="$l('form_label_discountSalesAmount_N') || '不包含佣金'"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="d-flex align-items-center my-3">
      <h6 class="m-0">
        {{ $l('form_header_takeOrder') || '接单抬头设置' }}
      </h6>
      <el-divider direction="vertical" />
      <b-button size="sm" variant="outline-success" @click="addTakeOrder">
        {{ $l('btn_addTakeOrder') || '新增接单设置' }}
      </b-button>
    </div>

    <div class="cust-takeOrder-list">
      <el-form
        v-for="(form, index) in listTakeOrder"
        :key="index"
        ref="form"
        :model="form"
        :rules="takeOrderRules"
        size="mini"
      >
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item
              :label="$l('form_label_takeOrderOrgCode') || '接单抬头设置'"
              prop="takeOrderOrgCode"
            >
              <dict-select
                v-model="form.takeOrderOrgCode"
                :selectedLabel.sync="form.takeOrderOrgName"
                :placeholder="
                  $l('form_placeholder_takeOrderOrg') || '请选择接单抬头设置'
                "
                url="/digitalCenter/common/dict/system"
                :body="{ dictType: 'takeOrderOrgCode' }"
                clearable
                filterable
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$l('form_label_takeOrderOrgName') || '收汇抬头'"
            >
              <el-input v-model="form.takeOrderOrgName" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item>
              <template #label>
                <div style="width: 100px;"><br /></div>
              </template>
              <div
                class="text-right"
                style="width: 100%;display: inline-block;"
              >
                <el-tooltip
                  effect="dark"
                  :content="$l('INDEX.btn_tips_del') || '删除'"
                  placement="top"
                >
                  <i
                    class="el-icon-delete text-danger tool-btn"
                    style="font-size: 24px;"
                    @click="deleteTakeOrder(index)"
                  />
                </el-tooltip>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item
              :label="$l('form_label_takeOrderType') || '订单类型限制'"
              prop="takeOrderType"
            >
              <dict-select
                v-model="form.takeOrderType"
                :placeholder="
                  $l('form_placeholder_takeOrderType') || '请选择订单类型限制'
                "
                url="/digitalCenter/common/dict/system"
                :body="{ dictType: 'takeOrderType' }"
                clearable
                filterable
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$l('form_label_executeOrgCode') || '国内业务执行公司'"
              prop="executeOrgCode"
            >
              <dict-select
                v-model="form.executeOrgCode"
                :selectedLabel.sync="form.executeOrgName"
                :placeholder="
                  $l('form_placeholder_executeOrg') || '请选择国内业务执行公司'
                "
                url="/digitalCenter/common/dict/system"
                :body="{ dictType: 'takeOrderOrgCode' }"
                clearable
                filterable
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="
                $l('form_label_executeOrgName') || '国内公司采购合同甲方抬头'
              "
            >
              <el-input v-model="form.executeOrgName" readonly />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div
        style="text-align: center"
        v-if="!listTakeOrder || !listTakeOrder.length"
      >
        <img src="/image/static/img/nodata.png" style="width: 120px;" />
        <div class="no-data mt-2">
          {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
        </div>
      </div>
    </div>

    <div class="d-flex align-items-center my-3">
      <h6 class="m-0">{{ $l('form_header_bank') || '客户银行账号' }}</h6>
      <el-divider direction="vertical" />
      <b-button size="sm" variant="outline-success" @click="addBank">
        {{ $l('btn_addBank') || '新增银行账号' }}
      </b-button>
    </div>

    <div class="cust-bank-list">
      <el-form
        v-for="(form, index) in listBank"
        :key="index"
        ref="form"
        :model="form"
        :rules="bankRules"
        size="mini"
      >
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_bankName') || '开户银行'"
              prop="bankName"
            >
              <el-input
                v-model="form.bankName"
                :placeholder="
                  $l('form_placeholder_bankName') || '请输入开户银行'
                "
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_bankAccountType') || '账户性质'"
              prop="bankAccountType"
            >
              <el-select
                v-model="form.bankAccountType"
                :placeholder="
                  $l('form_placeholder_bankAccountType') || '请选择账户性质'
                "
                style="width: 100%"
                filterable
                clearable
              >
                <el-option
                  value="0"
                  :label="$l('form_label_bankAccountType_0') || '公司'"
                />
                <el-option
                  value="1"
                  :label="$l('form_label_bankAccountType_1') || '个人'"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_bankAccountKind') || '账号类别'"
              prop="bankAccountKind"
            >
              <dict-select
                v-model="form.bankAccountKind"
                url="/master/common/dict/biz"
                :body="{ dictType: 'bankAccountKind' }"
                :placeholder="
                  $l('form_placeholder_bankAccountKind') || '请选择账号类别'
                "
                size="mini"
                clearable
                filterable
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <template #label>
                <div style="width: 100px;"><br /></div>
              </template>
              <div
                class="text-right"
                style="width: 100%;display: inline-block;"
              >
                <el-tooltip
                  effect="dark"
                  :content="$l('INDEX.btn_tips_del') || '删除'"
                  placement="top"
                >
                  <i
                    class="el-icon-delete text-danger tool-btn"
                    style="font-size: 24px;"
                    @click="deleteBank(index)"
                  />
                </el-tooltip>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_bankAccountName') || '账户名称'"
              prop="bankAccountName"
            >
              <el-input
                v-model="form.bankAccountName"
                :placeholder="
                  $l('form_placeholder_bankAccountName') || '请输入账户名称'
                "
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_bankAccountNo') || '银行账号'"
              prop="bankAccountNo"
            >
              <el-input
                v-model="form.bankAccountNo"
                :placeholder="
                  $l('form_placeholder_bankAccountNo') || '请输入银行账号'
                "
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div style="text-align: center" v-if="!listBank || !listBank.length">
        <img src="/image/static/img/nodata.png" style="width: 120px;" />
        <div class="no-data mt-2">
          {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const initTakeOrder = {}
const initBank = {}
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: { custCode: { type: String, default: '' } },
  data() {
    return {
      formData: {},
      listTakeOrder: [],
      listBank: [],
      takeOrderRules: {
        takeOrderOrgCode: [
          {
            required: true,
            message:
              this.$l('form_placeholder_takeOrderOrg') || '请选择接单抬头设置',
            trigger: 'change',
          },
        ],
        takeOrderType: [
          {
            required: true,
            message:
              this.$l('form_placeholder_takeOrderType') || '请选择订单类型限制',
            trigger: 'change',
          },
        ],
        executeOrgCode: [
          {
            required: true,
            message:
              this.$l('form_placeholder_executeOrg') ||
              '请选择国内业务执行公司',
            trigger: 'change',
          },
        ],
      },
      bankRules: {
        bankName: [
          {
            required: true,
            message: this.$l('form_placeholder_bankName') || '请输入开户银行',
            trigger: 'blur',
          },
        ],
        bankAccountType: [
          {
            required: true,
            message:
              this.$l('form_placeholder_bankAccountType') || '请选择账户性质',
            trigger: 'change',
          },
        ],
        bankAccountKind: [
          {
            required: true,
            message:
              this.$l('form_placeholder_bankAccountKind') || '请选择账号类别',
            trigger: 'change',
          },
        ],
        bankAccountName: [
          {
            required: true,
            message:
              this.$l('form_placeholder_bankAccountName') || '请输入账户名称',
            trigger: 'blur',
          },
        ],
        bankAccountNo: [
          {
            required: true,
            message:
              this.$l('form_placeholder_bankAccountNo') || '请输入银行账号',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.getBaseData()
      this.getTakeOrderData()
      this.getBankData()
    },
    async getBaseData() {
      if (!this.custCode) return
      const res = await this.$api
        .masterCustomerV2DetailApi({ custCode: this.custCode })
        .catch(() => null)
      if (!res) return
      this.formData = res.body
    },
    async getTakeOrderData() {
      if (!this.custCode) return
      const res = await this.$api
        .masterCustomerTakeOrderListApi({ custCode: this.custCode })
        .catch(() => null)
      if (!res) return
      this.listTakeOrder = res.body.data
    },
    async getBankData() {
      if (!this.custCode) return
      const res = await this.$api
        .masterCustomerBankListApi({ custCode: this.custCode })
        .catch(() => null)
      if (!res) return
      this.listBank = res.body.data
    },
    addTakeOrder() {
      this.listTakeOrder.push({ ...initTakeOrder })
    },
    async deleteTakeOrder(index) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      this.listTakeOrder.splice(index, 1)
    },
    addBank() {
      this.listBank.push({ ...initBank })
    },
    async deleteBank(index) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      this.listBank.splice(index, 1)
    },
    validate() {
      return validate.formValidate([
        ...(this.$refs.form || []),
        this.$refs.baseForm,
      ])
    },
    async complete() {
      if (!(await this.validate())) return

      const params = {
        ...this.formData,
        listTakeOrder: this.listTakeOrder,
        listBank: this.listBank,
        custCode: this.custCode,
      }

      if (this.loadingOpen()) return

      const res = await this.$api
        .masterCustomerSaveFinanceApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return false
      if (res.status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return false
      }
      return true
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .cust-takeOrder-list,
  .cust-bank-list {
    .el-form {
      background-color: #f4f6f9;
      padding: 16px;
      padding-bottom: 6px;
      border-radius: 5px;
      margin-bottom: 16px;
    }
    .el-form:last-child {
      margin-bottom: 0;
    }
    .no-data {
      color: #606266;
      font-size: 13px;
    }
  }
}
</style>
